'use strict';
var React = require('react');

class OrderDiaryComponent extends React.Component {
    render() {
        return null;
    }
}

module.exports = OrderDiaryComponent;